import { NgModule } from '@angular/core';
import { CanAccessPipe} from './can-access.pipe';
import { TranslationPipe } from './translation.pipe';
import {ExtendDatePipe} from "./extend-date.pipe";

@NgModule({
  declarations: [
    CanAccessPipe,
    TranslationPipe,
    ExtendDatePipe
  ],
  imports: [],
  exports: [
    CanAccessPipe,
    TranslationPipe,
    ExtendDatePipe
  ],
  providers: []
})
export class PipesModule {}
